import './style.scss'
import ContactForm from "./form";

export default function ContactBlock() {

    return <div id="contactBlock" className="contact-block">
        <div className="contact-block__wrapper container">
            <div className="contact-block__column" data-aos="fade-up">
                <h2 className="contact-block__title title">Welcome to your system.</h2>
                <span className="contact-block__subtitle">Let’s build the next step.</span>
            </div>

            <div className="contact-block__column">
                <ContactForm/>
            </div>
        </div>
    </div>
}